import { createAction, props } from "@ngrx/store";

export const LOAD_STATE = 'Load State';
export const SET_STATE = 'Set_State';

export const loadState = createAction(LOAD_STATE);
export const setLoadState = createAction(SET_STATE, props<{ isLoaded: boolean }>());
